import * as UrlUtilities from '../lib/UrlUtilities';

class LibraryPost {
	constructor(postData, srcId) {
		this.title = postData.Title;
		this.description = postData.Description;
		this.url = postData.links[0] ? UrlUtilities.useLocalProtocol(postData.links[0].url) : "";
		this.imageurl = UrlUtilities.useLocalProtocol(postData.Image);
		this.srcId = srcId;
	}
}

export default LibraryPost;



// WEBPACK FOOTER //
// ./src/models/LibraryPost.js